// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__32FeD","button":"NotFound_button__1ALpm"};